import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Spinner } from "../../../../../../../../Components";
import { GetParams } from "../../../../../../../../Helper";
import {
  GetAllClubTransactionAPI,
  GetCurrentMemberCommissionAPI,
  GetClubMonthlyCommissionAPI,
} from "../../../../../../../../Services";
import {
  PSIClubCommissionsTableComponent,
  CommissionsFilterComponent,
} from "../ContactProfilePSIClubCommissionsComponent";

export const PSIClubCommissionsComponent = ({
  parentTranslationPath,
  translationPath,
  contactId,
}) => {
  const { t } = useTranslation(parentTranslationPath);

  const [isLoading, setIsLoading] = useState({
    allClubTransaction: false,
    clubTotalCommission: false,
    clubMonthlyCommission: false,
  });
  const dateRangeDefault = {
    startDate: null,
    endDate: null,
    key: "selection",
    selectedDateType: 1,
  };
  const [dateFilter, setDateFilter] = useState(dateRangeDefault);
  const [isDatePickerChanged, setIsDatePickerChanged] = useState(false);
  const [commissionPercentage, setCommissionPercentage] = useState(0);
  const [totalCommission, setTotalCommission] = useState(0);
  const [monthlyCommission, setMonthlyCommission] = useState(0);
  const [allClubTransaction, setAllClubTransaction] = useState({
    result: [],
    totalCount: 0,
  });
  const [isClearFiltersClicked, setIsClearFiltersClicked] = useState(false);
  const [filterValues, setFilterValues] = useState({
    transactionStatus: null,
    commissionStatus: null,
  });
  const [filter, setFilter] = useState({
    pageSize: +parseInt(localStorage.getItem("Pagination")) || 25,
    pageIndex: 0,
    leadId: null,
    leadName: null,
    memberId: null,
    unitRefNumber: null,
    adminMemberId: null,
    transactionStatus: null,
    contactId: +GetParams("id"),
    commissionStatus: null,
    CommissionPaymentDateFrom: null,
    CommissionPaymentDateTo: null,
  });

  const GetAllClubTransaction = useCallback(
    async (filterUpdate) => {
      setIsLoading((item) => ({ ...item, allClubTransaction: true }));
      let commissionPaymentDateFrom = null;
      let commissionPaymentDateTo = null;

      if (dateFilter && dateFilter.startDate && dateFilter.endDate) {
        commissionPaymentDateFrom = moment(dateFilter.startDate)
          .startOf("day")
          .format("YYYY-MM-DD");
        commissionPaymentDateTo = moment(dateFilter.endDate).format(
          "YYYY-MM-DD"
        );
      }

      const res = await GetAllClubTransactionAPI({
        ...filter,
        pageIndex: filter.pageIndex + 1,
        CommissionPaymentDateFrom: commissionPaymentDateFrom || null,
        CommissionPaymentDateTo: commissionPaymentDateTo || null,
      });
      if (!(res && res.status && res.status !== 200)) {
        setAllClubTransaction({
          result: (res && res.result) || [],
          totalCount: (res && res.totalCount) || 0,
        });
      } else {
        setAllClubTransaction({
          result: [],
          totalCount: 0,
        });
      }
      setIsLoading((item) => ({ ...item, allClubTransaction: false }));
    },
    [filter, dateFilter]
  );

  const GetClubTotalCommission = useCallback(async () => {
    setIsLoading((item) => ({ ...item, clubTotalCommission: true }));
    const res = await GetCurrentMemberCommissionAPI({
      contactId: +GetParams("id"),
    });
    if (res) setCommissionPercentage(res);
    else setCommissionPercentage(0);
    setIsLoading((item) => ({ ...item, clubTotalCommission: false }));
  }, []);

  const GetClubMonthlyCommission = useCallback(async () => {
    setIsLoading((item) => ({ ...item, clubMonthlyCommission: true }));
    const res = await GetClubMonthlyCommissionAPI({
      contactId: +GetParams("id"),
    });
    if (res && res.status && res.status !== 200) setMonthlyCommission(0);
    else setMonthlyCommission(0);
    setIsLoading((item) => ({ ...item, clubMonthlyCommission: false }));
  }, []);

  useEffect(() => {
    GetClubMonthlyCommission();
    GetClubTotalCommission();
  }, [GetClubMonthlyCommission, GetClubTotalCommission]);

  useEffect(() => {
    GetAllClubTransaction();
  }, [GetAllClubTransaction, filter]);

  return (
    <div className="w-100">
      <Spinner
        isActive={
          isLoading?.allClubTransaction ||
          isLoading?.clubTotalCommission ||
          isLoading?.clubMonthlyCommission
        }
        isAbsolute
      />
      <div className="d-flex-column mt-3  mb-2">
        <CommissionsFilterComponent
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          filter={filter}
          setFilter={setFilter}
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          setIsClearFiltersClicked={setIsClearFiltersClicked}
          setDateFilter={setDateFilter}
          dateRangeDefault={dateRangeDefault}
          dateFilter={dateFilter}
          isDatePickerChanged={isDatePickerChanged}
          setIsDatePickerChanged={setIsDatePickerChanged}
          isClearFiltersClicked={isClearFiltersClicked}
          reloadData={(newFilter) => GetAllClubTransaction(newFilter)}
        />
        <div></div>
      </div>
      <div className="w-100 px-3">
        <PSIClubCommissionsTableComponent
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          setFilter={setFilter}
          filter={filter}
          allClubTransaction={allClubTransaction}
          reloadData={(newFilter) => GetAllClubTransaction(newFilter)}
          commissionPercentage={commissionPercentage}
        />
      </div>
    </div>
  );
};
